/* FLURR DYNAMIC REWARDS — LIVE CART AMOUNT */

(function () {
  if (window.flurrDynamicRewardsInstalled) return;
  window.flurrDynamicRewardsInstalled = true;

  let updateTimer = null;
  let lastTier = null;
  let updating = false;

  const thresholds = [199900, 299900, 499900];

  function getTier(amount) {
    if (amount >= thresholds[2]) return 3;
    if (amount >= thresholds[1]) return 2;
    if (amount >= thresholds[0]) return 1;
    return 0;
  }

  function getProgress(amount) {
    let progress = 0;

    if (amount < thresholds[0]) {
      progress = amount * 16.6667 / thresholds[0];
    } else if (amount < thresholds[1]) {
      progress = 16.6667 +
        ((amount - thresholds[0]) * 33.3333 / 100000);
    } else {
      progress = 50 +
        ((amount - thresholds[1]) * 33.3333 / 200000);
    }

    return Math.min(progress, 83.3333);
  }

  function formatPrice(amount) {
    return '₹' + Math.round(amount / 100)
      .toLocaleString('en-IN');
  }

  async function updateRewards() {
    if (updating) return;

    updating = true;

    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Cart fetch failed');

      const cart = await response.json();

      const rewards = document.querySelector(
        '#Cart-Drawer .flurr-rewards'
      );

      if (!rewards) return;

      // Match existing Liquid calculation
      const amount = cart.original_total_price;

      const tier = getTier(amount);
      const progress = getProgress(amount);

      rewards.dataset.flurrTier = tier;
      rewards.dataset.flurrTotal = amount;

      // Update progress bar
      const progressBar = rewards.querySelector(
        '.flurr-rewards__progress'
      );

      if (progressBar) {
        progressBar.style.width = progress + '%';
      }

      // Update milestone circles
      rewards.querySelectorAll(
        '.flurr-rewards__milestone'
      ).forEach((milestone, index) => {

        const unlocked = amount >= thresholds[index];

        milestone.classList.toggle(
          'is-unlocked',
          unlocked
        );

        const dot = milestone.querySelector(
          '.flurr-rewards__dot'
        );

        if (dot) {
          dot.textContent = unlocked ? '✓' : index + 1;
        }
      });

      // Update reward message
      const message = rewards.querySelector(
        '.flurr-rewards__message'
      );

      if (message) {
        if (tier === 3) {
          message.textContent =
            "You've unlocked all FLURR rewards! 🎉";
        } else {
          const nextThreshold = thresholds[tier];

          const nextDiscount = [5, 10, 15][tier];

          message.textContent =
            'Add ' +
            formatPrice(nextThreshold - amount) +
            ' more to unlock ' +
            nextDiscount +
            '% OFF';
        }
      }

      // Celebrate when a new tier is crossed
      if (lastTier !== null && tier > lastTier) {
        if (typeof window.flurrCelebrateRewards === 'function') {
          window.flurrCelebrateRewards();
        }
      }

      lastTier = tier;

    } catch (error) {
      console.error('FLURR Rewards update:', error);
    } finally {
      updating = false;
    }
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(updateRewards, 350);
  }

  // Detect cart drawer content updates
  function observeCart() {
    const drawer = document.getElementById('Cart-Drawer');

    if (!drawer) return;

    const observer = new MutationObserver(function (mutations) {
      const changed = mutations.some(function (mutation) {
        return mutation.type === 'childList';
      });

      if (changed) scheduleUpdate();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  // Common Shopify theme cart events
  [
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'cart:rendered'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleUpdate);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCart);
  } else {
    observeCart();
  }

})();


/* FLURR REWARDS — CONFETTI ON TIER UNLOCK */

window.flurrCelebrateRewards = function () {
  var drawer = document.getElementById('Cart-Drawer');
  if (!drawer) return;

  var rewards = drawer.querySelector('.flurr-rewards');
  if (rewards) {
    rewards.classList.remove('is-celebrating');
    void rewards.offsetWidth; // restart animation
    rewards.classList.add('is-celebrating');
  }

  var canvas = document.createElement('canvas');
  canvas.className = 'flurr-confetti';
  drawer.appendChild(canvas);

  var box = drawer.getBoundingClientRect();
  canvas.width = box.width;
  canvas.height = box.height;

  // burst from the progress bar
  var ox = canvas.width / 2;
  var oy = canvas.height * 0.2;
  if (rewards) {
    var r = rewards.getBoundingClientRect();
    oy = r.top - box.top + r.height / 2;
  }

  var ctx = canvas.getContext('2d');
  var colors = ['#ff5500', '#15b79e', '#ffd166', '#ef476f', '#118ab2', '#ffffff'];
  var pieces = [];

  for (var i = 0; i < 90; i++) {
    pieces.push({
      x: ox + (Math.random() - 0.5) * 80,
      y: oy,
      vx: (Math.random() - 0.5) * 14,
      vy: -Math.random() * 12 - 4,
      w: 6 + Math.random() * 6,
      h: 4 + Math.random() * 4,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.3,
      color: colors[i % colors.length]
    });
  }

  var duration = 1800;
  var start = null;

  function frame(ts) {
    if (!start) start = ts;
    var t = ts - start;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = Math.max(0, 1 - t / duration);

    pieces.forEach(function (p) {
      p.vy += 0.35;
      p.vx *= 0.99;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    });

    if (t < duration) {
      requestAnimationFrame(frame);
    } else {
      canvas.remove();
    }
  }

  requestAnimationFrame(frame);
};